// Buzağı Besleme modülü — ortak yardımcılar
export const DAY_LABELS = ["Pzt", "Salı", "Çrş", "Prş", "Cuma", "Cmt", "Paz"];

const MONTHS_TR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export function monthLabel(m) {
  if (!m) return "—";
  const [y, mo] = m.split("-");
  const idx = parseInt(mo, 10) - 1;
  return `${MONTHS_TR[idx] || mo} ${y}`;
}

export function thisMondayISO() {
  const d = new Date();
  const day = d.getDay() || 7;
  d.setDate(d.getDate() - (day - 1));
  return d.toISOString().slice(0, 10);
}

export function errMsg(err, fallback) {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d[0]?.msg || fallback;
  if (typeof d === "string") return d;
  return err?.message || fallback;
}
